
/**
 * Componente para o divisor entre as seções da frase
 * Linha branca reta de 100% de largura
 */
export const PhraseDivider = () => (
  <div
    style={{
      width: '100%',
      height: '0.5rem',
      backgroundColor: 'white',
      margin: '0'
    }}
  />
);
